import React from "react";
import cn from "classnames";
import Image from "next/image";
import Slider from "react-slick";
import styles from "./styles.module.scss";
import { AnimationChart } from "../../Animation";

const MarketingSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
  };

  return (
    <div className={cn(styles.slider)}>
      <div className="container container_sm">
        <h2>View key metrics of your business</h2>
        <Slider {...settings} className={styles.slick}>
          <div className={styles.slide}>
            <label className="h4">Monthly Recurring Revenue</label>
            <AnimationChart />
            <p className={`text_xl ${styles.description}`}>
              Analyze your app MRR and revenue across marketing channels,
              countries, products.
              <br />
              View information about each user, including purchases history and
              attribution channel.
            </p>
          </div>
          <div className={styles.slide}>
            <label className="h4">All crucial metrics in one place</label>
            <div className={styles.imageBig}>
              <Image
                src="/images/marketing-slider/image2.svg"
                width="1008"
                height="326"
                alt="metrics"
                loading="lazy"
              />
            </div>
            <div className={styles.imageSmall}>
              <Image
                src="/images/marketing-slider/image2-small.svg"
                width="288"
                height="191"
                alt="metrics"
                loading="lazy"
              />
            </div>
            <p className={`text_xl ${styles.description}`}>
              All crucial app metrics in one place – understand money metrics
              such as Revenue, Sales, Proceeds, ARPU etc. Track your active
              subscriptions count, trials failed charges, refunds.
            </p>
          </div>
          <div className={styles.slide}>
            <label className="h4">Dive into detailed user information</label>
            <div className={styles.imageBig}>
              <Image
                src="/images/marketing-slider/image3.svg"
                width="1008"
                height="469"
                alt="user information"
                loading="lazy"
              />
            </div>
            <div className={styles.imageSmall}>
              <Image
                src="/images/marketing-slider/image3-small.svg"
                width="193"
                height="191"
                alt="user information"
                loading="lazy"
              />
            </div>
            <p className={`text_xl ${styles.description}`}>
              View user profile with detailed data inside – device and user
              properties (including custom ones), attribution settings etc.
              Analyze user’s trial/subscription flow.
            </p>
          </div>
          <div className={styles.slide}>
            <label className="h4">Cohort analysis for subscriptions</label>
            <div className={styles.imageBig}>
              <Image
                src="/images/marketing-slider/image4.svg"
                width="574"
                height="476"
                alt="user information"
                loading="lazy"
              />
            </div>
            <div className={styles.imageSmall}>
              <Image
                src="/images/marketing-slider/image4.svg"
                width="574"
                height="476"
                alt="user information"
                loading="lazy"
              />
            </div>
            <p className={`text_xl ${styles.description}`}>
              Cohort analysis is a great tool for a deep understanding how users
              are renewing subscriptions and how subscribers and revenue retains
            </p>
          </div>
        </Slider>
      </div>
    </div>
  );
};

export default MarketingSlider;
